import { motion } from "framer-motion";
import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

// Premium luxury easing curves
const luxuryEasing = [0.6, 0.01, 0.05, 0.95] as const;
const swiftEasing = [0.4, 0, 0.2, 1] as const;

const pageVariants = {
  initial: { 
    opacity: 0,
    y: 40,
    scale: 0.98,
    filter: "blur(8px)",
  },
  animate: { 
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: luxuryEasing,
      staggerChildren: 0.08,
    }
  },
  exit: { 
    opacity: 0,
    y: -30,
    scale: 0.99,
    filter: "blur(4px)",
    transition: {
      duration: 0.4,
      ease: swiftEasing,
    }
  }
};

export const PageTransition = ({ children }: PageTransitionProps) => {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="will-change-transform"
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
